import { DeleteIcon, InfoIcon } from '@assets/icons';
import { FormCard, FormSelect, FormToggle } from '@components/form';
import { Group } from '@components/layout';
import { Tooltip } from '@components/tooltip';
import { Typography } from '@components/typography';
import { Box, Collapse, MenuItem } from '@mui/material';
import { useField } from 'formik';

export const AutoDeleteField = () => {
  const [autoDeleteEnabledField] = useField<boolean>('autoDeleteEnabled');
  return (
    <FormCard>
      <Group alignItems="center" justifyContent="space-between">
        <Group gap={1} alignItems="center">
          <DeleteIcon size={16} />
          <Typography variant="body2">Auto Delete</Typography>
          <Tooltip title="Automatically delete the server after it has been stopped for the specified number of days.">
            <InfoIcon size={10} />
          </Tooltip>
        </Group>
        <FormToggle name="autoDeleteEnabled" sx={{ mr: 0 }} maintainGutters={false} />
      </Group>
      <Collapse in={autoDeleteEnabledField.value}>
        <Group gap={2} alignItems="flex-end" sx={{ mt: 1.5 }}>
          <FormSelect label="Delete after" name="autoDeleteTimeoutDays" small>
            <MenuItem value={7}>7 days</MenuItem>
            <MenuItem value={14}>14 days</MenuItem>
            <MenuItem value={30}>30 days</MenuItem>
            <MenuItem value={60}>60 days</MenuItem>
            <MenuItem value={90}>90 days</MenuItem>
          </FormSelect>
          <Box flex={1} />
        </Group>
      </Collapse>
    </FormCard>
  );
};
